import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { Dropdown } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../../functions/server';

class Edit extends React.Component {

    state = {
        customerTypeId: this.props.item.type,
        customerType: this.props.customerType
    }


    getCustomerTypeName() {
        if (this.state.edit) {
            let customerType = this.props.customerType;
            let customerTypeId = this.state.customerTypeId;
            let customerName = "";
            customerType.map((c) => {
                if (c.value == customerTypeId) {
                    customerName = c.text;
                }
            })
            return customerName;
        } else {
            let customerTypeId = this.props.item.type;
            let customerType = this.props.customerType;
            let name = '';
            customerType.map((c) => {
                if (c.value == customerTypeId) {
                    name = c.text;
                }
            })
            return name;
        }
    }

    getCustomerTypeDailog() {
        if (!this.props.menuPermission.edit) { 
            alert('You Are Not Allow To Access!!!!'); return; 
        }
        let customerTypeId = this.state.customerTypeId;
        this.setState({ customerTypeId, dialog: true, edit: true })
    }

    customer = (f, { value }) => {
        let context = this;
        $.ajax({
            type: 'POST', data: { id: context.props.item.id, value },
            url: Server() + 'customer/changeCustomerType.php',
            success: function(data) {
                if (data == 1) {
                    context.setState({ customerTypeId: value });
                }
                else {
                    alert('Error!!!')
                }
            },
            error: function(err) {
            context.setState({ load: false });
              alert('Try again!!!')
            }
          });
      }

    render() {
        let customertype = this.getCustomerTypeName();
        if (this.state.dialog) {
            return (
                <Dialog fullWidth={true} maxWidth={'sm'} open={this.state.dialog}
                    onClose={ () => { this.setState({ dialog: false }) } }
                    aria-labelledby="max-width-dialog-title" >
                    <DialogTitle id="max-width-dialog-title">{'Executive'}</DialogTitle>
                    <DialogContent style={{height: 250}}>
                        <Dropdown placeholder='Executive' style={{ borderColor: '#5A9CBB', fontSize: 11 }}
                        fluid search selection onChange={this.customer}
                        options={this.props.customerType} value={this.state.customerTypeId} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={ () => { this.setState({ dialog: false }) } } color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            )
        }

        return (
            <td onClick={this.getCustomerTypeDailog.bind(this)}>
                <b><u style={{color: '#11B2D2'}}>{customertype}</u></b>
            </td>
        );
    }
}

export default Edit;
